/**------------------------------------------------------
 * App info types
 */
export enum EnumAppInfoTypes {
	MaintenanceInfo = 'maintenance-info',
	HomeInfo        = 'home-info'
}
